/**
 * values for setting the 'phone format' in 'phone' form field
 */
const PHONE_FORMAT = {
  INTERNATIONAL:      'international',
  INTERNATIONAL_FLAG: 'international_flag',
  UK:                 'uk',
  US:                 'us',
};

const PHONE_FORMAT_ALL = _.values(PHONE_FORMAT, 'value');

const PHONE_FORMAT_LIST = [
  { text: 'United Kingdom', value: PHONE_FORMAT.UK, description: '' },
  { text: 'North America', value: PHONE_FORMAT.US, description: '' },
  { text: 'International', value: PHONE_FORMAT.INTERNATIONAL, description: '' },
  { text: 'International (with Country Picker)', value: PHONE_FORMAT.INTERNATIONAL_FLAG, description: '' },
];

export { PHONE_FORMAT, PHONE_FORMAT_LIST, PHONE_FORMAT_ALL };
